import {fabric} from 'fabric'

export function makeDottedLineOnDots(canvas) {
    let waterPipePoints = [];
    let waterPipeLines = [];

    canvas.on("mouse:down", function(event) {
        const pointer = canvas.getPointer(event.e);
        const positionX = pointer.x;
        const positionY = pointer.y;

        // Add small circle as an indicative point
        const circlePoint = new fabric.Circle({
            radius: 5,
            fill: "blue",
            left: positionX,
            top: positionY,
            selectable: false,
            originX: "center",
            originY: "center",
            hoverCursor: "auto"
        });

        canvas.add(circlePoint);

        // Store the points to draw the lines
        waterPipePoints.push(circlePoint);
        console.log(waterPipePoints);
        if (waterPipePoints.length > 1) {
            // Just draw a line using the last two points, so we don't need to clear
            // and re-render all the lines
            var startPoint = waterPipePoints[waterPipePoints.length - 2];
            var endPoint = waterPipePoints[waterPipePoints.length - 1];

            var waterLine = new fabric.Line(
                [
                    startPoint.get("left"),
                    startPoint.get("top"),
                    endPoint.get("left"),
                    endPoint.get("top")
                ],
                {
                    stroke: "blue",
                    strokeWidth: 4,
                    hasControls: false,
                    hasBorders: false,
                    strokeDashArray: [5, 5],
                    selectable: false,
                    lockMovementX: true,
                    lockMovementY: true,
                    hoverCursor: "default",
                    originX: "center",
                    originY: "center"
                }
            );

            waterPipeLines.push(waterLine);

            canvas.add(waterLine);
        }
    });

    canvas.renderAll();

}
export function makeDottedLine(canvas,color) {
    let line, isDown;
    let startx = [];
    let endx = [];
    let starty = [];
    let endy = [];
    let temp = 0;
    fabric.Object.prototype.transparentCorners = false;

    canvas.on('mouse:down', function(o){
        isDown = true;
        var pointer = canvas.getPointer(o.e);

        var points = [pointer.x, pointer.y, pointer.x, pointer.y];
        startx[temp] = pointer.x;
        starty[temp] = pointer.y;
        line = new fabric.Line(points, {
            strokeWidth: 2,
            stroke: color,
            originX: 'center',
            strokeDashArray: [5, 5],
            originY: 'center'
        });
        canvas.add(line);
    });

    canvas.on('mouse:move', function(o){
        canvas.renderAll();
        if (!isDown) return;
        var pointer = canvas.getPointer(o.e);
        line.set({ x2: pointer.x, y2: pointer.y });

        endx[temp] = pointer.x;
        endy[temp] = pointer.y;
        canvas.renderAll();
    });


    canvas.on('mouse:up', function(o){
        line.setCoords();
        isDown = false;

    });

    canvas.on('mouse:over', function(e) {
        if(e.target && e.target.setStroke) {
            e.target?.setStroke('blue');
        }
        canvas.renderAll();
    });

    canvas.on('mouse:out', function(e) {
        if(e.target && e.target.setStroke) {
            e.target?.setStroke('var(--theme-text-color)');
        }
        canvas.renderAll();
    });


}